<script setup lang="ts">
defineOptions({ inheritAttrs: false });
</script>

<template>
    <VListItem
        v-bind="$attrs"
        class="b-list-item"
    >
        <template
            v-if="$slots.prepend"
            #prepend
        >
            <slot name="prepend" />
        </template>

        <template
            v-if="$slots.append"
            #append
        >
            <slot name="append" />
        </template>

        <template
            v-if="$slots.title"
            #title
        >
            <slot name="title" />
        </template>

        <template
            v-if="$slots.subtitle"
            #subtitle
        >
            <slot name="subtitle" />
        </template>

        <slot />
    </VListItem>
</template>
